import { isSafePhoneValue } from '../../is-safe-phone-value.js';
/** Blocks RFC 3966 phone-context delimiters so a stored number can't retarget a tel: link. */
export const rejectPhoneContextInjection = (schema) => schema.refine((value) => value == null || isSafePhoneValue(value), 'Invalid phone number.');
//# sourceMappingURL=reject-phone-context-injection.js.map